export default "__VITE_ASSET__Bbq1$WHy__"